/** Shared label for the services area (outer advanced tab + inner sub-tab). */
export const BOOKING_V2_ADVANCED_SERVICES_TAB_LABEL_KEY = 'bookingV2.advanced.services.tabLabel';
